import React from 'react';
import { Image, Group, Line, Rect, Text, Circle, Stage, Layer } from 'react-konva';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var URLImage = /*#__PURE__*/function (_React$Component) {
  _inherits(URLImage, _React$Component);

  var _super = _createSuper(URLImage);

  function URLImage(props) {
    var _this;

    _classCallCheck(this, URLImage);

    _this = _super.call(this, props);
    _this.state = {
      image: null
    };
    return _this;
  }

  _createClass(URLImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadImage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (oldProps.src !== this.props.src) {
        this.loadImage();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.image.removeEventListener('load', this.handleLoad.bind(this));
    }
  }, {
    key: "loadImage",
    value: function loadImage() {
      this.image = new window.Image();
      this.image.src = this.props.src;
      this.image.addEventListener('load', this.handleLoad.bind(this));
    }
  }, {
    key: "handleLoad",
    value: function handleLoad() {
      this.setState({
        image: this.image
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(Image, {
        x: this.props.x,
        y: this.props.y,
        width: this.props.width,
        height: this.props.height,
        image: this.state.image,
        dragBoundFunc: this.props.dragBoundFunc,
        onDragEnd: this.props.onDragEnd,
        onTap: this.props.onTap,
        onClick: this.props.onClick,
        draggable: this.props.draggable,
        offsetX: this.props.offsetX,
        offsetY: this.props.offsetY,
        ref: function ref(node) {
          _this2.imageNode = node;
        }
      });
    }
  }]);

  return URLImage;
}(React.Component);

var endLineLength = 50;

var MeasurementLine = /*#__PURE__*/function (_React$Component) {
  _inherits(MeasurementLine, _React$Component);

  var _super = _createSuper(MeasurementLine);

  function MeasurementLine() {
    _classCallCheck(this, MeasurementLine);

    return _super.apply(this, arguments);
  }

  _createClass(MeasurementLine, [{
    key: "render",
    value: function render() {
      var _this = this;

      var clickHandler = function clickHandler() {
        if (_this.props.showModal) _this.props.showModal(_this.props.label, _this.props.length, _this.inputChanged.bind(_this), _this.props.minValue, _this.props.maxValue);
      };

      var element = /*#__PURE__*/React.createElement(Group, {
        ref: function ref(node) {
          return _this.root = node;
        },
        rotation: this.props.rotation,
        x: this.props.startx,
        y: this.props.starty,
        preventDefault: false
      }, /*#__PURE__*/React.createElement(Line, {
        ref: function ref(mainLine) {
          _this.mainLine = mainLine;
        },
        stroke: "red",
        points: [0, -endLineLength / 2, this.props.length, -endLineLength / 2]
      }), /*#__PURE__*/React.createElement(Line, {
        ref: function ref(startLine) {
          _this.startLine = startLine;
        },
        stroke: "red",
        points: [0, -endLineLength, 0, 0]
      }), /*#__PURE__*/React.createElement(Line, {
        ref: function ref(endLine) {
          _this.endLine = endLine;
        },
        stroke: "red",
        points: [this.props.length, -endLineLength, this.props.length, 0]
      }), /*#__PURE__*/React.createElement(Group, {
        x: this.startPosition(),
        y: -120,
        onTap: clickHandler,
        onClick: clickHandler
      }, /*#__PURE__*/React.createElement(Rect, {
        width: this.neededWidth(),
        height: 100,
        strokeWidth: 5,
        stroke: "black",
        fill: "white"
      }), /*#__PURE__*/React.createElement(Text, {
        x: 10,
        y: 10,
        ref: function ref(text) {
          _this.text = text;
        },
        fontSize: 100,
        fontStyle: "bold",
        text: this.props.length + " mm"
      }), this.editIcon(this.props)));
      return element;
    }
  }, {
    key: "setLength",
    value: function setLength(length, moveStartPoint) {
      this.text.text(length + " mm");
      var mainLinePoints = this.mainLine.points();

      if (moveStartPoint) {
        var lengthChange = mainLinePoints[2] - length;
        var startLinePoints = this.startLine.points();
        startLinePoints[0] = lengthChange;
        startLinePoints[2] = lengthChange;
        this.startLine.points(startLinePoints);
        mainLinePoints[0] = lengthChange;
      } else {
        mainLinePoints[2] = length;
        var endLinePoints = this.endLine.points();
        endLinePoints[0] = length;
        endLinePoints[2] = length;
        this.endLine.points(endLinePoints);
      }

      this.mainLine.points(mainLinePoints);
    }
  }, {
    key: "inputChanged",
    value: function inputChanged(value) {
      if (this.props.lengthInputChanged) {
        this.props.lengthInputChanged(value);
      }
    }
  }, {
    key: "convertToAbsolutePosition",
    value: function convertToAbsolutePosition(pos) {
      return this.root.getAbsoluteTransform().point(pos);
    }
  }, {
    key: "neededWidth",
    value: function neededWidth() {
      var length = this.props.length < 1000 ? 500 : 550;
      if (this.props.readOnly) length -= 100;
      return length;
    }
  }, {
    key: "startPosition",
    value: function startPosition() {
      var start = this.props.length / 2 - this.neededWidth() / 2;
      if (this.props.avoidOverFlow) start = Math.max(0, start);
      return start;
    }
  }, {
    key: "editIcon",
    value: function editIcon(props) {
      if (!this.props.readOnly) return /*#__PURE__*/React.createElement(URLImage, {
        y: 10,
        x: this.neededWidth() - 90,
        src: props.penIcon || "img/pen.png"
      });
    }
  }]);

  return MeasurementLine;
}(React.Component);

var door = /*#__PURE__*/function (_React$Component) {
  _inherits(door, _React$Component);

  var _super = _createSuper(door);

  function door(props) {
    _classCallCheck(this, door);

    return _super.call(this);
  }

  _createClass(door, [{
    key: "render",
    value: function render() {
      var _this = this;

      var measurements = this.props.measurements;
      this.listColor = this.props.listColor || defaultListColor$2;
      return /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(MeasurementLine, {
        rotation: 0,
        y: 0,
        startx: measurements.doorFromLeft,
        length: measurements.doorWidth,
        showModal: this.props.showModal,
        lengthInputChanged: this.onDoorWidthChanged.bind(this),
        penIcon: this.props.penIcon,
        minValue: this.props.minDoorWidth,
        label: "Ovilehden aukon leveys"
      }), /*#__PURE__*/React.createElement(UpGlass, {
        upGlassEnabled: measurements.upGlassEnabled,
        width: measurements.doorWidth,
        height: measurements.upGlassHeight,
        fromLeft: measurements.doorFromLeft,
        color: this.props.color,
        allowAddOrRemoveGlass: this.props.allowAddOrRemoveGlass,
        addGlass: this.props.addGlass,
        removeGlass: this.props.removeGlass,
        onToggleGlass: this.props.onToggleUpGlass,
        listColor: this.listColor
      }), /*#__PURE__*/React.createElement(Rect, {
        ref: function ref(doorGlass) {
          _this.doorGlass = doorGlass;
        },
        width: measurements.doorWidth,
        height: measurements.doorHeight,
        y: this.doorFromCeiling(measurements),
        x: measurements.doorFromLeft,
        strokeWidth: 5,
        stroke: "black",
        fill: this.props.color
      }), /*#__PURE__*/React.createElement(Rect, {
        x: measurements.doorFromLeft,
        y: this.doorFromCeiling(measurements) + measurements.doorHeight,
        width: measurements.doorWidth,
        height: measurements.height - this.doorFromCeiling(measurements) - measurements.doorHeight,
        fill: "white"
      }), upperGlassHeightMeasurement(this, measurements, this.props), /*#__PURE__*/React.createElement(MeasurementLine, {
        ref: function ref(heightMeasurement) {
          _this.doorHeightMeasurement = heightMeasurement;
        },
        rotation: 90,
        starty: this.doorFromCeiling(measurements),
        startx: measurements.doorFromLeft + parseInt(measurements.doorWidth) / 2,
        length: measurements.doorHeight,
        showModal: this.props.showModal,
        lengthInputChanged: this.props.doorHeightChanged.bind(this),
        penIcon: this.props.penIcon,
        minValue: this.props.minDoorHeight,
        label: "Ovilehden aukon korkeus"
      }), /*#__PURE__*/React.createElement(MeasurementLine, {
        lengthInputChanged: this.props.spaceUnderDoorChanged.bind(this),
        showModal: this.props.showModal,
        rotation: 90,
        starty: measurements.doorHeight + this.doorFromCeiling(measurements),
        startx: measurements.doorFromLeft + parseInt(measurements.doorWidth) / 2,
        length: parseInt(measurements.spaceUnderDoor),
        penIcon: this.props.penIcon,
        label: "Ilmarako"
      }), /*#__PURE__*/React.createElement(Circle, {
        ref: function ref(handle) {
          _this.handle = handle;
        },
        y: measurements.upGlassHeight + measurements.doorHeight / 2,
        x: measurements.doorHandness == "left" || measurements.doorHandness == 0 ? measurements.doorFromLeft + parseInt(measurements.doorWidth) - 60 : measurements.doorFromLeft + 60,
        radius: 30,
        fill: "black"
      }));
    }
  }, {
    key: "doorFromCeiling",
    value: function doorFromCeiling(measurements) {
      if (measurements.upGlassEnabled) return measurements.upGlassHeight;else return measurements.height - measurements.doorHeight - measurements.spaceUnderDoor;
    }
  }, {
    key: "dragBoundHeightFunc",
    value: function dragBoundHeightFunc(pos) {
      var relativePos = this.convertToRelativePosition(pos);
      relativePos.x = this.props.measurements.doorWidth / 2;
      var prerviousUpGlassHeight = this.upGlassheight;
      var newUpGlassheight = parseInt(prerviousUpGlassHeight + relativePos.y);

      if (newUpGlassheight < this.props.minUpGlassHeight) {
        relativePos.y += this.props.minUpGlassHeight - newUpGlassheight;
        newUpGlassheight = this.props.minUpGlassHeight;
      } else if (newUpGlassheight > this.props.maxUpGlassHeight) {
        relativePos.y -= newUpGlassheight - this.props.maxUpGlassHeight;
        newUpGlassheight = this.props.maxUpGlassHeight;
      }

      this.upGlassheight = newUpGlassheight;
      this.doorGlass.height(this.doorGlass.height() - (newUpGlassheight - prerviousUpGlassHeight));
      this.doorGlass.y(newUpGlassheight);
      this.heightMeasurement.setLength(newUpGlassheight);
      this.doorHeightMeasurement.setLength(this.doorGlass.height(), true);
      return this.doorGlass.getAbsoluteTransform().point(relativePos);
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd(e) {
      if (this.props.doorHeightChanged) this.props.doorHeightChanged(this.doorGlass.height());
      if (this.props.upGlassHeightChanged) this.props.upGlassHeightChanged(this.upGlassheight);
    }
  }, {
    key: "onDoorWidthChanged",
    value: function onDoorWidthChanged(width) {
      if (this.props.onDoorWidthChanged) this.props.onDoorWidthChanged(width);
    }
  }, {
    key: "convertToRelativePosition",
    value: function convertToRelativePosition(pos) {
      return this.doorGlass.getAbsoluteTransform().copy().invert().point(pos);
    }
  }]);

  return door;
}(React.Component);

var UpGlass = function UpGlass(props) {
  if (props.upGlassEnabled) return /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(Rect, {
    width: props.width,
    height: props.height,
    y: 0,
    x: props.fromLeft,
    strokeWidth: 5,
    stroke: "black",
    fill: props.color
  }), /*#__PURE__*/React.createElement(Rect, {
    key: "upperList",
    width: props.width,
    height: 30,
    y: 0,
    x: props.fromLeft,
    fill: props.listColor
  }), removeUpGlassControl(props));else if (props.allowAddOrRemoveGlass) {
    return /*#__PURE__*/React.createElement(URLImage, {
      x: props.fromLeft + props.width / 2,
      y: 100,
      width: 200,
      height: 200,
      offsetX: 100,
      offsetY: 100,
      onTap: function onTap() {
        return props.onToggleGlass();
      },
      onClick: function onClick() {
        return props.onToggleGlass();
      },
      src: props.addGlass
    });
  } else {
    return null;
  }
};

var removeUpGlassControl = function removeUpGlassControl(props) {
  if (props.allowAddOrRemoveGlass) {
    return /*#__PURE__*/React.createElement(URLImage, {
      x: props.fromLeft + props.width / 2,
      y: props.height / 2,
      width: 200,
      height: 200,
      offsetX: 100,
      offsetY: 100,
      onTap: function onTap() {
        return props.onToggleGlass();
      },
      onClick: function onClick() {
        return props.onToggleGlass();
      },
      src: props.removeGlass
    });
  } else {
    return null;
  }
};

var upperGlassHeightMeasurement = function upperGlassHeightMeasurement(sender, measurements, props) {
  if (measurements.upGlassEnabled) {
    return /*#__PURE__*/React.createElement(MeasurementLine, {
      ref: function ref(heightMeasurement) {
        sender.heightMeasurement = heightMeasurement;
      },
      rotation: 90,
      y: 0,
      startx: measurements.doorFromLeft + parseInt(measurements.doorWidth) / 2,
      length: measurements.upGlassHeight,
      lengthInputChanged: props.upGlassHeightChanged.bind(sender),
      showModal: props.showModal,
      avoidOverFlow: true,
      penIcon: props.penIcon,
      label: "Yl\xE4lasin korkeus"
    });
  } else {
    return null;
  }
};

var defaultListColor$2 = "gray";

var sideGlass = /*#__PURE__*/function (_React$Component) {
  _inherits(sideGlass, _React$Component);

  var _super = _createSuper(sideGlass);

  function sideGlass(props) {
    var _this;

    _classCallCheck(this, sideGlass);

    _this = _super.call(this);
    _this.side = props.side;
    return _this;
  }

  _createClass(sideGlass, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var component;
      var addButonX = this.props.x;
      if (this.props.side == "left") addButonX += this.props.width - 150;else addButonX += 150;

      if (this.props.drawGlass) {
        var removeGlassElement;
        this.listColor = this.props.listColor || defaultListColor$1;
        if (this.props.allowAddOrRemoveGlass) removeGlassElement = /*#__PURE__*/React.createElement(URLImage, {
          offsetX: 100,
          offsetY: 100,
          x: addButonX,
          y: this.props.height / 2,
          width: 200,
          height: 200,
          onTap: this.onToggleGlass.bind(this),
          onClick: this.onToggleGlass.bind(this),
          src: this.props.removeGlass
        });
        component = /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(MeasurementLine, {
          key: "widhtM",
          ref: function ref(widthMeasurement) {
            _this2.widthMeasurement = widthMeasurement;
          },
          startx: this.props.x,
          starty: 0,
          rotation: 0,
          lengthInputChanged: this.glassWidthInputChanged.bind(this),
          length: this.props.width,
          showModal: this.props.showModal,
          minValue: this.props.minWidth,
          maxValue: this.props.maxWidth,
          penIcon: this.props.penIcon,
          label: "Sivulasin aukon leveys"
        }), this.getHeightMeasurement(this.props), /*#__PURE__*/React.createElement(Rect, {
          ref: function ref(node) {
            return _this2.glassNode = node;
          },
          width: this.props.width,
          height: this.props.height,
          y: this.props.upperEdge,
          x: this.props.x,
          strokeWidth: 5,
          stroke: "black",
          fill: this.props.color
        }), this.edges(this.props), /*#__PURE__*/React.createElement(URLImage, {
          src: this.props.verticalArrows,
          dragBoundFunc: this.dragBoundHeightFunc.bind(this),
          onDragEnd: this.onHeightDragEnd.bind(this),
          draggable: true,
          x: this.props.x + this.props.width / 2,
          y: this.props.upperEdge + this.props.height,
          width: 200,
          height: 200,
          offsetX: 100,
          offsetY: 100
        }), this.getWidthControl(this.props), removeGlassElement);
      } else if (this.props.allowAddOrRemoveGlass) {
        component = /*#__PURE__*/React.createElement(URLImage, {
          x: addButonX,
          y: this.props.height / 2,
          width: 200,
          height: 200,
          offsetX: 100,
          offsetY: 100,
          onTap: this.onToggleGlass.bind(this),
          onClick: this.onToggleGlass.bind(this),
          src: this.props.addGlass
        });
      } else component = /*#__PURE__*/React.createElement(Group, null);

      return component;
    }
  }, {
    key: "dragBoundHeightFunc",
    value: function dragBoundHeightFunc(pos) {
      var relativePos = this.convertToRelativePosition(pos);
      relativePos.x = this.props.width / 2;
      var glassHeight = Math.min(Math.max(parseInt(relativePos.y), this.props.minHeight), this.props.maxHeight);
      relativePos.y = glassHeight;
      this.glassNode.height(glassHeight);
      this.heightMeasurement.setLength(parseInt(glassHeight), this.side === "left");
      return this.glassNode.getAbsoluteTransform().point(relativePos);
    }
  }, {
    key: "dragBoundWidthFunc",
    value: function dragBoundWidthFunc(pos) {
      var relativePos = this.convertToRelativePosition(pos);
      relativePos.y = this.props.height / 2;

      if (this.side === "left") {
        var newWidth = this.glassNode.width() - relativePos.x;

        if (newWidth > this.props.maxWidth) {
          relativePos.x += newWidth - this.props.maxWidth;
        } else if (newWidth < this.props.minWidth) {
          relativePos.x -= this.props.minWidth - newWidth;
        }

        this.glassNode.x(this.glassNode.x() + relativePos.x);
        this.glassNode.width(this.glassNode.width() - relativePos.x);
      } else {
        var _newWidth = relativePos.x;

        if (_newWidth > this.props.maxWidth) {
          relativePos.x = this.props.maxWidth;
        } else if (_newWidth < this.props.minWidth) {
          relativePos.x = this.props.minWidth;
        }

        this.glassNode.width(relativePos.x);
      }

      this.widthMeasurement.setLength(parseInt(this.glassNode.width()), this.side === "left");
      return this.glassNode.getAbsoluteTransform().point(relativePos);
    }
  }, {
    key: "onHeightDragEnd",
    value: function onHeightDragEnd(evt) {
      if (this.props.heightChanged) {
        this.props.heightChanged(parseInt(this.glassNode.height()));
      }
    }
  }, {
    key: "onWidthDragEnd",
    value: function onWidthDragEnd(evt) {
      if (this.props.widthChanged) {
        this.props.widthChanged(parseInt(this.glassNode.width()));
      }
    }
  }, {
    key: "onToggleGlass",
    value: function onToggleGlass() {
      if (this.props.glassToggled) {
        this.props.glassToggled();
      }
    }
  }, {
    key: "convertToRelativePosition",
    value: function convertToRelativePosition(pos) {
      return this.glassNode.getAbsoluteTransform().copy().invert().point(pos);
    }
  }, {
    key: "convertToAbsolutePosition",
    value: function convertToAbsolutePosition(pos) {
      return this.glassNode.getAbsoluteTransform().point(pos);
    }
  }, {
    key: "getWidthControl",
    value: function getWidthControl(props) {
      var x = 0;
      if (this.side === "left") x = props.x;else x = this.props.x + props.width;
      return /*#__PURE__*/React.createElement(URLImage, {
        dragBoundFunc: this.dragBoundWidthFunc.bind(this),
        src: this.props.horizontalArrows,
        width: 200,
        height: 200,
        onDragEnd: this.onWidthDragEnd.bind(this),
        offsetX: 100,
        offsetY: 100,
        draggable: true,
        x: x,
        y: props.height / 2,
        radius: 100
      });
    }
  }, {
    key: "glassHeightInputChanged",
    value: function glassHeightInputChanged(glassHeight) {
      if (this.props.heightChanged) this.props.heightChanged(glassHeight);
    }
  }, {
    key: "glassWidthInputChanged",
    value: function glassWidthInputChanged(glassWidth) {
      if (this.props.widthChanged) this.props.widthChanged(glassWidth);
    }
  }, {
    key: "getHeightMeasurement",
    value: function getHeightMeasurement(props) {
      var _this3 = this;

      var x = 0;
      var y = 0;
      var rotation = 0;

      if (this.side === "left") {
        x = props.x - 120;
        y = this.props.height + props.upperEdge;
        rotation = -90;
      } else {
        rotation = 90;
        x = this.props.x + props.width + 120;
        y = props.upperEdge;
      }

      return /*#__PURE__*/React.createElement(MeasurementLine, {
        minValue: this.props.minHeight,
        maxValue: this.props.maxHeight,
        ref: function ref(heightMeasurement) {
          _this3.heightMeasurement = heightMeasurement;
        },
        startx: x,
        starty: y,
        rotation: rotation,
        length: this.props.height,
        lengthInputChanged: this.glassHeightInputChanged.bind(this),
        showModal: this.props.showModal,
        label: "Sivulasin aukon korkeus",
        penIcon: props.penIcon
      });
    }
  }, {
    key: "edges",
    value: function edges(props) {
      var parts = [];
      if (props.side == "left") parts.push( /*#__PURE__*/React.createElement(Rect, {
        key: "sidelist",
        width: 30,
        height: props.height,
        y: props.upperEdge,
        x: props.x,
        fill: this.listColor
      }));else parts.push( /*#__PURE__*/React.createElement(Rect, {
        key: "sidelist",
        width: listWidth,
        height: props.height,
        y: props.upperEdge,
        x: props.x + props.width - listWidth,
        fill: this.listColor
      }));
      parts.push( /*#__PURE__*/React.createElement(Rect, {
        key: "upperList",
        width: props.width,
        height: 30,
        y: props.upperEdge,
        x: props.x,
        fill: this.listColor
      }));
      if (props.lowerEdgeType == "list") parts.push( /*#__PURE__*/React.createElement(Rect, {
        key: "bottom",
        width: props.width,
        height: 30,
        y: props.upperEdge + props.height - listWidth,
        x: props.x,
        fill: this.listColor
      }));else {
        var numberOfAttachments = Math.ceil(props.width / floorAttachmentTrsehold);

        if (numberOfAttachments == 1) {
          if (props.side == "left") parts.push(this.bottomAttachment(props.x + props.width - attachmentFromGlassEdge, props));else parts.push(this.bottomAttachment(props.x + attachmentFromGlassEdge, props));
        } else {
          var attachmenSpace = props.width - attachmentFromGlassEdge * 2;

          for (var i = 0; i < numberOfAttachments; i++) {
            parts.push(this.bottomAttachment(props.x + attachmentFromGlassEdge + i * attachmenSpace / (numberOfAttachments - 1), props));
          }
        }
      }
      return /*#__PURE__*/React.createElement(Group, null, parts);
    }
  }, {
    key: "bottomAttachment",
    value: function bottomAttachment(position, props) {
      return /*#__PURE__*/React.createElement(Rect, {
        key: position,
        width: floorAttachmentSize,
        height: floorAttachmentSize,
        y: props.roomHeight - floorAttachmentSize,
        x: position - floorAttachmentSize / 2,
        fill: this.listColor
      });
    }
  }]);

  return sideGlass;
}(React.Component);

sideGlass.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  removeGlass: PropTypes.string.isRequired,
  addGlass: PropTypes.string.isRequired
};
var defaultListColor$1 = "gray";
var listWidth = 30;
var floorAttachmentSize = 48;
var floorAttachmentTrsehold = 600;
var attachmentFromGlassEdge = 100;

var WallTiles = /*#__PURE__*/function (_React$Component) {
  _inherits(WallTiles, _React$Component);

  var _super = _createSuper(WallTiles);

  function WallTiles(props) {
    var _this;

    _classCallCheck(this, WallTiles);

    _this = _super.call(this, props);
    _this.state = {
      image: null
    };
    return _this;
  }

  _createClass(WallTiles, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadImage();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.image.removeEventListener('load', this.handleLoad.bind(this));
    }
  }, {
    key: "loadImage",
    value: function loadImage() {
      this.image = new window.Image();
      this.image.src = this.props.src;
      this.image.addEventListener('load', this.handleLoad.bind(this));
    }
  }, {
    key: "handleLoad",
    value: function handleLoad() {
      this.setState({
        image: this.image
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Rect, {
        x: 0,
        y: 0,
        width: this.props.width,
        height: this.props.height,
        fillPatternImage: this.state.image,
        fillPatternScaleX: 4,
        fillPatternScaleY: 4
      });
    }
  }]);

  return WallTiles;
}(React.Component);

var modalStyle = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
};
var offset = 250;

var glassWall = /*#__PURE__*/function (_React$Component) {
  _inherits(glassWall, _React$Component);

  var _super = _createSuper(glassWall);

  function glassWall(props) {
    var _this;

    _classCallCheck(this, glassWall);

    _this = _super.call(this, props);
    _this.state = {
      showModal: false
    };
    _this.ref = /*#__PURE__*/React.createRef();
    _this.widthAnimationFrame = null;
    _this.scheduleWidthUpdate = _this.scheduleWidthUpdate.bind(_assertThisInitialized(_this));
    _this.updateWidth = _this.updateWidth.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(glassWall, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var neededWidth = 2 * offset + parseInt(this.props.measurements.doorWallWidth);
      var neededHeight = 2.5 * offset + parseInt(this.props.measurements.height);
      this.listColor = this.props.listColor || defaultListColor;
      var scale = 1;

      if (Number.isFinite(this.state.width) && this.state.width > 0) {
        scale = this.state.width / neededWidth;
      }

      var upperEdge = this.props.measurements.upGlassEnabled ? 0 : this.props.measurements.height - this.props.measurements.spaceUnderDoor - this.props.measurements.doorHeight;
      var component;

      if (this.props.measurements.doorWallWidth && this.props.measurements.height) {
        component = /*#__PURE__*/React.createElement("div", {
          ref: this.ref
        }, /*#__PURE__*/React.createElement(Stage, {
          height: neededHeight * scale,
          width: neededWidth * scale,
          scaleY: scale,
          scaleX: scale
        }, /*#__PURE__*/React.createElement(Layer, null, /*#__PURE__*/React.createElement(URLImage, {
          x: offset,
          y: offset,
          width: this.props.measurements.doorWallWidth,
          height: this.props.measurements.height,
          src: this.props.background
        }), /*#__PURE__*/React.createElement(Group, {
          x: offset,
          y: offset,
          clipFunc: this.glassClipFunc.bind(this)
        }, /*#__PURE__*/React.createElement(WallTiles, {
          width: this.props.measurements.doorWallWidth,
          height: this.props.measurements.height,
          src: this.props.slateImage,
          ref: function ref(layer) {
            _this2.testlayer = layer;
          }
        })), /*#__PURE__*/React.createElement(Group, {
          x: offset,
          y: offset
        }, /*#__PURE__*/React.createElement(Rect, {
          ref: function ref(layer) {
            _this2.testlayer = layer;
          },
          width: this.props.measurements.doorWallWidth,
          height: this.props.measurements.height,
          strokeWidth: 5,
          stroke: "black"
        }), /*#__PURE__*/React.createElement(MeasurementLine, {
          startx: 0,
          length: this.props.measurements.doorFromLeft,
          starty: this.props.measurements.height + offset,
          label: "Ovi vasemmalta",
          lengthInputChanged: this.props.doorFromLeftChanged ? this.props.doorFromLeftChanged.bind(this) : undefined,
          showModal: this.showMeasurementModal.bind(this),
          penIcon: this.props.penIcon
        }), this.totalGlassWidthMeasurementLine(this.props), this.totalWallWidthMeasurementLine(this.props), this.totalHeightMeasurementLine(this.props), /*#__PURE__*/React.createElement(door, {
          measurements: this.props.measurements,
          doorHeightChanged: this.props.doorHeightChanged,
          onDoorWidthChanged: this.props.onDoorWidthChanged,
          upGlassHeightChanged: this.props.upGlassHeightChanged,
          spaceUnderDoorChanged: this.props.spaceUnderDoorChanged,
          color: this.props.glassColor,
          minUpGlassHeight: this.props.glassSizeLimits.minUpGlassHeight,
          maxUpGlassHeight: this.props.glassSizeLimits.maxUpGlassHeight,
          minDoorWidth: this.props.glassSizeLimits.minDoorWidth,
          minDoorHeight: this.props.glassSizeLimits.minDoorHeight,
          showModal: this.showMeasurementModal.bind(this),
          allowAddOrRemoveGlass: this.props.glassSizeLimits.allowAddOrRemoveGlass,
          removeGlass: this.props.removeGlass,
          addGlass: this.props.addGlass,
          penIcon: this.props.penIcon,
          onToggleUpGlass: this.props.upGlassToggled,
          listColor: this.listColor
        }), /*#__PURE__*/React.createElement(sideGlass, {
          side: "left",
          heightChanged: this.props.leftSideGlassHeightChanged,
          widthChanged: this.props.leftSideGlassWidthChanged,
          glassToggled: this.props.leftSideGlassToggled,
          drawGlass: this.props.measurements.leftSideGlassEnabled,
          x: this.props.measurements.doorFromLeft - this.props.measurements.leftSideGlassWidth,
          width: this.props.measurements.leftSideGlassWidth,
          minWidth: this.props.glassSizeLimits.leftSideGlassMinWidth,
          maxWidth: this.props.glassSizeLimits.leftSideGlassMaxWidth,
          height: this.props.measurements.leftSideGlassHeight,
          minHeight: this.props.glassSizeLimits.leftSideGlassMinHeight,
          maxHeight: this.props.glassSizeLimits.leftSideGlassMaxHeight,
          roomHeight: this.props.measurements.height,
          color: this.props.glassColor,
          removeGlass: this.props.removeGlass,
          addGlass: this.props.addGlass,
          verticalArrows: this.props.verticalArrows,
          horizontalArrows: this.props.horizontalArrows,
          showModal: this.showMeasurementModal.bind(this),
          allowAddOrRemoveGlass: this.props.glassSizeLimits.allowAddOrRemoveGlass,
          penIcon: this.props.penIcon,
          upperEdge: upperEdge,
          lowerEdgeType: this.lowerEdgeType(this.props.measurements.height - upperEdge - this.props.measurements.leftSideGlassHeight),
          listColor: this.listColor
        }), /*#__PURE__*/React.createElement(sideGlass, {
          side: "right",
          heightChanged: this.props.rightSideGlassHeightChanged,
          widthChanged: this.props.rightSideGlassWidthChanged,
          glassToggled: this.props.rightSideGlassToggled,
          drawGlass: this.props.measurements.rightSideGlassEnabled,
          x: this.props.measurements.doorFromLeft + parseInt(this.props.measurements.doorWidth),
          width: this.props.measurements.rightSideGlassWidth,
          minWidth: this.props.glassSizeLimits.rightSideGlassMinWidth,
          maxWidth: this.props.glassSizeLimits.rightSideGlassMaxWidth,
          height: this.props.measurements.rightSideGlassHeight,
          roomHeight: this.props.measurements.height,
          minHeight: this.props.glassSizeLimits.rightSideGlassMinHeight,
          maxHeight: this.props.glassSizeLimits.rightSideGlassMaxHeight,
          color: this.props.glassColor,
          removeGlass: this.props.removeGlass,
          addGlass: this.props.addGlass,
          verticalArrows: this.props.verticalArrows,
          horizontalArrows: this.props.horizontalArrows,
          showModal: this.showMeasurementModal.bind(this),
          allowAddOrRemoveGlass: this.props.glassSizeLimits.allowAddOrRemoveGlass,
          penIcon: this.props.penIcon,
          upperEdge: upperEdge,
          lowerEdgeType: this.lowerEdgeType(this.props.measurements.height - upperEdge - this.props.measurements.rightSideGlassHeight),
          listColor: this.listColor
        }), this.hinges(this.props.measurements)))), /*#__PURE__*/React.createElement(Modal, {
          isOpen: this.state.showModal,
          style: modalStyle
        }, /*#__PURE__*/React.createElement("label", null, this.state.modalLabel), /*#__PURE__*/React.createElement("input", {
          type: "number",
          defaultValue: this.state.modalValue,
          onChange: function onChange(sender) {
            return _this2.modalInputChanged(_this2.clamp(parseInt(sender.target.value) || 0, _this2.state.modalMinValue, _this2.state.modalMaxValue));
          },
          min: this.state.modalMinValue,
          max: this.state.modalMaxValue
        }), /*#__PURE__*/React.createElement("button", {
          onClick: this.closeModal.bind(this)
        }, "Sulje")));
      } else component = /*#__PURE__*/React.createElement("div", {
        ref: this.ref
      });

      return component;
    }
  }, {
    key: "hinges",
    value: function hinges(measurements) {
      var upperEdge = measurements.height - measurements.spaceUnderDoor - measurements.doorHeight;
      var upperHinge = upperEdge + hingeFromEdge;
      var lowerHinge = upperEdge + measurements.doorHeight - hingeFromEdge;

      if (measurements.doorHandness == "left" || measurements.doorHandness == 0) {
        var sideGlassPoint = 0;

        if (measurements.leftSideGlassEnabled) {
          if (measurements.upGlassEnabled) sideGlassPoint = measurements.leftSideGlassHeight;else sideGlassPoint = upperEdge + measurements.leftSideGlassHeight;
        }

        var bottomHingeHalfHinge = sideGlassPoint < lowerHinge;
        var upperHingeHalfHinge = sideGlassPoint < upperHinge;
        return /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(Rect, {
          x: measurements.doorFromLeft - (upperHingeHalfHinge ? 0 : hingeWidth / 2),
          y: upperHinge - hingeHeight / 2,
          width: upperHingeHalfHinge ? hingeWidth / 2 : hingeWidth,
          height: hingeHeight,
          fill: this.listColor
        }), /*#__PURE__*/React.createElement(Rect, {
          x: measurements.doorFromLeft - (bottomHingeHalfHinge ? 0 : hingeWidth / 2),
          y: lowerHinge - hingeHeight / 2,
          width: bottomHingeHalfHinge ? hingeWidth / 2 : hingeWidth,
          height: hingeHeight,
          fill: this.listColor
        }));
      } else {
        var _sideGlassPoint = 0;

        if (measurements.rightSideGlassEnabled) {
          if (measurements.upGlassEnabled) _sideGlassPoint = measurements.rightSideGlassHeight;else _sideGlassPoint = upperEdge + measurements.rightSideGlassHeight;
        }

        var _bottomHingeHalfHinge = _sideGlassPoint < lowerHinge;

        var _upperHingeHalfHinge = _sideGlassPoint < upperHinge;

        return /*#__PURE__*/React.createElement(Group, null, /*#__PURE__*/React.createElement(Rect, {
          x: measurements.doorFromLeft + measurements.doorWidth - hingeWidth / 2,
          y: upperHinge - hingeHeight / 2,
          width: _upperHingeHalfHinge ? hingeWidth / 2 : hingeWidth,
          height: hingeHeight,
          fill: this.listColor
        }), /*#__PURE__*/React.createElement(Rect, {
          x: measurements.doorFromLeft + measurements.doorWidth - hingeWidth / 2,
          y: lowerHinge - hingeHeight / 2,
          width: _bottomHingeHalfHinge ? hingeWidth / 2 : hingeWidth,
          height: hingeHeight,
          fill: this.listColor
        }));
      }
    }
  }, {
    key: "clamp",
    value: function clamp(value, min, max) {
      if (value < min || Number.isNaN(value)) value = min;else if (value > max) value = max;
      return value;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.testlayer) this.testlayer.globalCompositeOperation("source-over");
      this.updateWidth();

      if (typeof ResizeObserver === "function") {
        this.resizeObserver = new ResizeObserver(this.scheduleWidthUpdate);

        if (this.ref.current) {
          this.resizeObserver.observe(this.ref.current);
        }
      }

      window.addEventListener("resize", this.scheduleWidthUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      window.removeEventListener("resize", this.scheduleWidthUpdate);

      if (this.widthAnimationFrame !== null && typeof window.cancelAnimationFrame === "function") {
        window.cancelAnimationFrame(this.widthAnimationFrame);
      }
    }
  }, {
    key: "scheduleWidthUpdate",
    value: function scheduleWidthUpdate() {
      var _this3 = this;

      if (this.widthAnimationFrame !== null) return;

      if (typeof window.requestAnimationFrame !== "function") {
        this.updateWidth();
        return;
      }

      this.widthAnimationFrame = window.requestAnimationFrame(function () {
        _this3.widthAnimationFrame = null;

        _this3.updateWidth();
      });
    }
  }, {
    key: "updateWidth",
    value: function updateWidth() {
      var control = this.ref.current;
      if (!control) return;
      var boundingWidth = typeof control.getBoundingClientRect === "function" ? control.getBoundingClientRect().width : 0;
      var width = control.clientWidth || boundingWidth || control.offsetWidth;
      if (!Number.isFinite(width) || width <= 0) return;
      this.setState(function (prevState) {
        if (prevState.width === width) return null;
        return {
          width: width
        };
      });
    }
  }, {
    key: "showMeasurementModal",
    value: function showMeasurementModal(label, value, onchanged, minValue, maxValue) {
      this.setState({
        showModal: true,
        modalValue: value,
        modalLabel: label,
        modalMinValue: minValue,
        modalMaxValue: maxValue
      });
      this.modalInputChanged = onchanged;
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "glassClipFunc",
    value: function glassClipFunc(ctx) {
      var measurements = this.props.measurements;
      var upperEdge = measurements.upGlassEnabled ? 0 : measurements.height - measurements.spaceUnderDoor - measurements.doorHeight;
      ctx.rect(0, 0, measurements.doorWallWidth, upperEdge);

      if (measurements.doorFromLeft > 0) {
        if (measurements.leftSideGlassEnabled) {
          if (measurements.leftSideGlassWidth < measurements.doorFromLeft) {
            ctx.rect(0, 0, measurements.doorFromLeft - measurements.leftSideGlassWidth, measurements.height);
          }

          var arealeftPoint = Math.max(0, measurements.doorFromLeft - measurements.leftSideGlassWidth);
          ctx.rect(arealeftPoint, measurements.leftSideGlassHeight + upperEdge, measurements.doorFromLeft - arealeftPoint, upperEdge + measurements.height - measurements.leftSideGlassHeight);
        } else {
          ctx.rect(0, upperEdge, measurements.doorFromLeft, measurements.height);
        }
      }

      if (measurements.doorWallWidth > measurements.doorFromLeft + measurements.doorWidth) {
        if (measurements.rightSideGlassEnabled) {
          var rightSideGlassEdgeFromRight = measurements.doorWallWidth - measurements.doorFromLeft - measurements.doorWidth - measurements.rightSideGlassWidth;

          if (rightSideGlassEdgeFromRight > 0) {
            ctx.rect(measurements.doorWallWidth - rightSideGlassEdgeFromRight, upperEdge, rightSideGlassEdgeFromRight, measurements.height);
          }

          Math.min(measurements.doorWallWidth, measurements.doorWallWidth - rightSideGlassEdgeFromRight);
          ctx.rect(measurements.doorFromLeft + measurements.doorWidth, measurements.rightSideGlassHeight + upperEdge, measurements.rightSideGlassWidth, measurements.height - measurements.rightSideGlassHeight);
        } else {
          ctx.rect(measurements.doorFromLeft + measurements.doorWidth, 0, measurements.doorWallWidth - measurements.doorFromLeft - measurements.doorWidth, measurements.height);
        }
      }
    }
  }, {
    key: "totalGlassWidthMeasurementLine",
    value: function totalGlassWidthMeasurementLine(props) {
      var measurements = props.measurements;

      if ((measurements.leftSideGlassEnabled || measurements.rightSideGlassEnabled) && props.showTotalGlassWallWidth) {
        var start = measurements.leftSideGlassEnabled ? measurements.doorFromLeft - measurements.leftSideGlassWidth : measurements.doorFromLeft;
        var length = measurements.doorWidth;
        if (measurements.leftSideGlassEnabled) length += measurements.leftSideGlassWidth;
        if (measurements.rightSideGlassEnabled) length += measurements.rightSideGlassWidth;
        return /*#__PURE__*/React.createElement(MeasurementLine, {
          startx: start,
          length: length,
          starty: -offset / 2,
          label: "Kokonaisleveys",
          lengthInputChanged: this.props.totalWidthChange ? this.props.totalWidthChanged.bind(this) : undefined,
          showModal: this.showMeasurementModal.bind(this),
          penIcon: props.penIcon
        });
      } else return /*#__PURE__*/React.createElement(Group, null);
    }
  }, {
    key: "totalWallWidthMeasurementLine",
    value: function totalWallWidthMeasurementLine(props) {
      if (props.showWallMeasurements) {
        var measurements = props.measurements;
        var length = measurements.doorWallWidth;
        return /*#__PURE__*/React.createElement(MeasurementLine, {
          startx: 0,
          length: length,
          starty: -offset / 2,
          label: "Leveys",
          lengthInputChanged: this.props.wallWidthChanged ? this.props.wallWidthChanged.bind(this) : undefined,
          showModal: this.showMeasurementModal.bind(this),
          penIcon: props.penIcon
        });
      } else return /*#__PURE__*/React.createElement(Group, null);
    }
  }, {
    key: "totalHeightMeasurementLine",
    value: function totalHeightMeasurementLine(props) {
      if (props.showWallMeasurements) {
        var measurements = props.measurements;
        var length = measurements.height;
        return /*#__PURE__*/React.createElement(MeasurementLine, {
          rotation: 90,
          startx: measurements.doorWallWidth,
          length: length,
          starty: 0,
          label: "Korkeus",
          lengthInputChanged: this.props.wallHeightChanged ? this.props.wallHeightChanged.bind(this) : undefined,
          showModal: this.showMeasurementModal.bind(this),
          penIcon: props.penIcon
        });
      } else return /*#__PURE__*/React.createElement(Group, null);
    }
  }, {
    key: "lowerEdgeType",
    value: function lowerEdgeType(space) {
      return space <= minListBottomEdgeHeight ? "floorAttachment" : "list";
    }
  }]);

  return glassWall;
}(React.Component);
var defaultListColor = "gray";
var minListBottomEdgeHeight = 25;
var hingeWidth = 115;
var hingeHeight = 90;
var hingeFromEdge = 283;

var getLimits = function getLimits(measurements) {
  var limits = {
    rightSideGlassMinHeight: minSideGlassHeight,
    rightSideGlassMaxHeight: measurements.upGlassEnabled ? measurements.height - minDistanceBetweenGlassAndFloor : measurements.doorHeight + measurements.spaceUnderDoor - minDistanceBetweenGlassAndFloor,
    rightSideGlassMinWidth: minSideGlassWidht,
    rightSideGlassMaxWidth: Math.max(0, measurements.doorWallWidth - measurements.doorFromLeft - measurements.doorWidth - glassMinDistanceToWall),
    leftSideGlassMaxHeight: measurements.upGlassEnabled ? measurements.height - minDistanceBetweenGlassAndFloor : measurements.doorHeight + measurements.spaceUnderDoor - minDistanceBetweenGlassAndFloor,
    leftSideGlassMinHeight: minSideGlassHeight,
    leftSideGlassMaxWidth: Math.max(0, measurements.doorFromLeft - glassMinDistanceToWall),
    leftSideGlassMinWidth: minSideGlassWidht,
    minUpGlassHeight: minUpGlassHeight,
    maxUpGlassHeight: maxUpGlassHeight,
    minDoorWidth: minDoorWidth,
    minDoorHeight: minDoorHeight,
    allowAddOrRemoveGlass: true
  };
  return limits;
};
var minDistanceBetweenGlassAndFloor = 17;
var glassMinDistanceToWall = 50;
var minSideGlassWidht = 100;
var minUpGlassHeight = 100;
var maxUpGlassHeight = 500;
var minSideGlassHeight = 300;
var minDoorWidth = 600;
var minDoorHeight = 1500;

export { glassWall as GlassWallComponent, getLimits };
